import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PauseIcon, PlayIcon, ZoomInIcon, XIcon } from "lucide-react";
import { Section, Reveal, Eyebrow, SectionTitle } from "./ui";
import { previews, previewChips } from "./data";
export function PreviewGallery() {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [playing, setPlaying] = useState(true);
  useEffect(() => {
    if (!playing || zoom) return;
    const timer = window.setInterval(() => {
      setActive(current => (current + 1) % previews.length);
    }, 4500);
    return () => window.clearInterval(timer);
  }, [playing, zoom]);
  return <Section id="previsualizacion" className="bg-[#f5f9fd]" data-id="element-157" data-mp="nlc2jwzy3kas">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-158" data-mp="njr43waifh7n">
        <Eyebrow data-id="element-159" data-mp="2udcsmr3gnet5">Mirá el material antes de comprar</Eyebrow>
        <SectionTitle data-id="element-160" data-mp="2pd8dp5i7as51">No tenés que imaginar qué vas a recibir. Miralo por dentro.</SectionTitle>
        <p className="mt-4 text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-161" data-mp="3tvcvqsnoir5g">
          Más de 500 páginas con explicaciones, ejemplos, recursos visuales y herramientas para
          volver a consultar cuando las necesites.
        </p>
      </Reveal>

      <Reveal delay={0.08} data-id="element-162" data-mp="7mk0wf5axrif">
        <div className="mx-auto mt-7 w-full max-w-3xl sm:mt-10" data-id="element-163" data-mp="7ma5gc1hms5c">
          <div className="relative overflow-hidden rounded-2xl border-4 border-white bg-white p-1.5 shadow-[0_26px_60px_-30px_rgba(23,50,77,0.55)] sm:rounded-[1.75rem] sm:p-3" data-id="element-164" data-mp="cgegb6dvjkbp">
            <div className="relative aspect-[4/5] overflow-hidden rounded-xl bg-[#edf4fc] sm:aspect-[16/10] sm:rounded-2xl" data-id="element-165" data-mp="lei120h1cd2g">
              <AnimatePresence mode="wait" data-id="element-166" data-mp="qf5tmqkwx1ys">
                <motion.img key={previews[active].src} src={previews[active].src} alt={previews[active].label} initial={{
                opacity: 0,
                scale: 1.02
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.23, 1, 0.32, 1]
              }} className="h-full w-full cursor-zoom-in object-contain" onClick={() => setZoom(true)} loading="lazy" data-id="element-167" data-mp="vdfkwq3inif4" />
              </AnimatePresence>
              <button type="button" onClick={() => setZoom(true)} className="absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full bg-white/95 text-[var(--ink)] shadow-md" aria-label="Ampliar muestra" data-id="element-168" data-mp="2u3ha9zbwlvip">
                <ZoomInIcon className="h-4 w-4" aria-hidden data-id="element-169" data-mp="3hssbfhx61rxd" />
              </button>
            </div>
          </div>

          <div className="mt-4 flex items-center justify-center gap-3" data-id="element-170" data-mp="3ctp6dxh6rlpe">
            <button type="button" onClick={() => setPlaying(v => !v)} className="flex h-9 w-9 flex-none items-center justify-center rounded-full border border-[#d8e6f4] bg-white text-[var(--accent)] shadow-sm" aria-label={playing ? "Pausar carrusel" : "Reanudar carrusel"} data-id="element-171" data-mp="3qtq8fg96sz6g">
              {playing ? <PauseIcon className="h-3.5 w-3.5" aria-hidden data-id="element-172" data-mp="e81j78kr0ujy" /> : <PlayIcon className="h-3.5 w-3.5" aria-hidden data-id="element-173" data-mp="a37yc1q5e8o" />}
            </button>
            <p className="max-w-xs text-center text-xs font-bold leading-snug text-[var(--ink)] sm:max-w-md sm:text-sm" data-id="element-174" data-mp="57mltauifp03">
              {previews[active].label}
            </p>
          </div>

          <div className="mt-4 flex justify-center gap-1.5" aria-label="Progreso del carrusel" data-id="element-175" data-mp="3ri8np4rexavn">
            {previews.map((p, index) => <button key={p.src} type="button" onClick={() => setActive(index)} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${index === active ? "w-6 bg-[var(--accent)]" : "w-1.5 bg-[#cdd9e4]"}`} aria-label={`Ver muestra ${index + 1}`} data-id="element-176" data-mp="3hqulgp82twyt" data-mpi={index} />)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.12} data-id="element-177" data-mp="axef91uee9h1">
        <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-178" data-mp="65wdwcogq6vj">
          {previewChips.map(c => <li key={c} className="rounded-full bg-white px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--accent)] shadow-sm" data-id="element-179" data-mp="171m4l8ip7za">
              {c}
            </li>)}
        </ul>
      </Reveal>

      <AnimatePresence data-id="element-180" data-mp="3ng4ct2ymf8zx">
        {zoom && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={() => setZoom(false)} className="fixed inset-0 z-[70] flex items-center justify-center bg-[var(--ink)]/90 p-4 backdrop-blur-sm" data-id="element-181" data-mp="3jbmsn2ocmtom">
            <button type="button" onClick={() => setZoom(false)} className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white text-[var(--ink)] shadow-lg" aria-label="Cerrar ampliación" data-id="element-182" data-mp="1k5hf7p976r7q">
              <XIcon className="h-5 w-5" aria-hidden data-id="element-183" data-mp="1yudx0e123ilj" />
            </button>
            <motion.img key={previews[active].src} src={previews[active].src} alt={previews[active].label} initial={{
          scale: 0.96,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="max-h-[88vh] max-w-full rounded-xl bg-white object-contain shadow-2xl" data-id="element-184" data-mp="1ytkq9d23kt3e" />
          </motion.div>}
      </AnimatePresence>
    </Section>;
}